import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/embr/assets/images/logopc1.svg'
import _imports_1 from '@/embr/assets/images/velas-icon.svg'
import _imports_2 from '@/embr/assets/images/twitter-icon1.png'
import _imports_3 from '@/embr/assets/images/medium-icon1.png'
import _imports_4 from '@/embr/assets/images/discord-icon1.png'
import _imports_5 from '@/embr/assets/images/gitbook-logo1.png'
import _imports_6 from '@/embr/assets/images/github-logo1.png'


const _hoisted_1 = { class: "relative custom-router-view" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative mt-32" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 left-0 flex justify-left pb-6 ml-8" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "flex items-center" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        class: "mr-1",
        width: "126",
        height: "30"
      })
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "absolute bottom-0 right-1 flex justify-end pb-6 mr-8" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "flex items-center" }, [
      /*#__PURE__*/_createTextVNode(" Powered by Abstract "),
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_1,
        width: "24",
        height: "24",
        class: "ml-2"
      })
    ])
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-1 items-end relative wave-footer-line ml-8 mr-8" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex relative mt-16" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "absolute grid grid-cols-3 flex-wrap justify-center sm:justify-between bottom-0 w-full px-6" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:flex col-span-1" }, [
      /*#__PURE__*/_createElementVNode("p", { style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300"} }, " Copyright ⓒ 2025 MondrianSwap. All rights reserved ")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "flex relative justify-center sm:gap-5 space-x-10 pb-3 col-span-3 sm:col-span-1" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://x.com/MondrianSwap",
        arget: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_2,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://t.me/Mondrianswap",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_3,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://discord.gg/YE44J8fxbh",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_4,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://modrianswap.gitbook.io/modrianswap",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_5,
          width: "25",
          class: "mx-auto"
        })
      ]),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://github.com/mondrian-swap/",
        target: "_blank"
      }, [
        /*#__PURE__*/_createElementVNode("img", {
          src: _imports_6,
          width: "25",
          class: "mx-auto"
        })
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "hidden sm:flex col-span-1 justify-end" }, [
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://pdfhost.io/v/3adZ06Tni_Terms_of_Use",
        target: "_blank",
        style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
      }, "Terms of Use"),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://pdfhost.io/v/UszMXyFl9_Risk_Disclosure",
        target: "_blank",
        style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
      }, "Risk Disclosure"),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://pdfhost.io/v/W4bxayu9w_Cookie_Policy",
        target: "_blank",
        style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
      }, "Cookie Policy"),
      /*#__PURE__*/_createElementVNode("a", {
        href: "https://pdfhost.io/v/2Yb79lYoz_Privacy_Policy",
        target: "_blank",
        style: {"color":"#ccc","font-size":"0.75rem","font-weight":"300","margin-right":"20px"}
      }, "Privacy Policy")
    ])
  ])
], -1)

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import AppNav from '@/embr/components/navs/AppNav.vue';
import AppFooterNav from '@/components/navs/AppFooterNav/AppFooterNav.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import AppHeaderBg from '@/embr/components/backgrounds/AppHeaderBg.vue';
import AppHero from '@/embr/components/heroes/AppHero.vue';
import GlobalStats from '@/embr/components/stats/GlobalStats.vue';
import DarkModeToggle from '@/components/btns/DarkModeToggle.vue';

/**
 * COMPOSABLES
 */

export default _defineComponent({
  setup(__props) {

const route = useRoute();
const { upToXLargeBreakpoint } = useBreakpoints();

/**
 * COMPUTED
 */
const isFarmsPage = computed(() => route.path === '/farm');
const isPortfolioPage = computed(() => route.path === '/my-portfolio');
const isInvestPage = computed(() => {
  return route.path === '/pools';
});
const isTradePage = computed(() => {
  return route.path === '/trade';
});
const showGlobalStats = computed(() => {
  return isInvestPage.value || isFarmsPage.value || isTradePage.value;
});
const isHomePage = computed(() => route.path === '/');

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AppNav),
    _createVNode(AppHeaderBg),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_router_view, {
        key: _ctx.$route.path
      })
    ]),
    _hoisted_2,
    _hoisted_3,
    _hoisted_4
  ]))
}
}

})